import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "xpage-top d-flex" }
const _hoisted_2 = {
  class: "xpage-top-row",
  id: "name"
}
const _hoisted_3 = { class: "xpage-top-profile" }
const _hoisted_4 = { class: "xpage-top-profile-icon" }
const _hoisted_5 = { class: "xpage-top-col" }
const _hoisted_6 = { class: "xpage-top-fullName" }
const _hoisted_7 = ["title"]
const _hoisted_8 = { class: "xpage-top-col-section" }
const _hoisted_9 = { class: "xpage-top-lenderName" }
const _hoisted_10 = ["title"]
const _hoisted_11 = {
  key: 0,
  class: "icon-student student-info xpage-top-studentName",
  id: "student"
}
const _hoisted_12 = ["title"]
const _hoisted_13 = { class: "xpage-top-status-dropdown" }
const _hoisted_14 = {
  key: 1,
  class: "xpage-top-details-status"
}
const _hoisted_15 = {
  key: 0,
  class: "xpage-top-right application-detail-details-stepper"
}
const _hoisted_16 = { class: "xcollapse-mobile" }
const _hoisted_17 = { class: "application-summary section-1" }
const _hoisted_18 = { class: "summary-items" }
const _hoisted_19 = { class: "summary-item" }
const _hoisted_20 = { class: "content" }
const _hoisted_21 = { class: "content" }
const _hoisted_22 = { class: "summary-item" }
const _hoisted_23 = { class: "content" }
const _hoisted_24 = { class: "content" }
const _hoisted_25 = { class: "summary-item" }
const _hoisted_26 = { class: "content" }
const _hoisted_27 = { class: "content" }

import { onMounted, computed, ref } from "vue";
import { storeToRefs } from "pinia";
import ApplicationStatus from "@/components/v2/application/ApplicationStatus.vue";
import { Permissions, PermissionLevels } from "@/models/permissions";
import PermissionsWrapper from "../../../wrappers/PermissionsWrapper.vue";
import { useApplicationStore } from "@/store/store/applicationVMStore";
import { useApplicationDetails } from "@/composables/application/useApplicationDetails";
import DetailsStepper from "@/components/v2/application/DetailsStepper.vue";
import functions from "@/use/functions";
import { useFeatures } from "@/use/useFeatures";


export default /*@__PURE__*/_defineComponent({
  __name: 'DetailsLOCV2',
  setup(__props) {

const applicationStore = useApplicationStore();
const { summary, applicationTab } = storeToRefs(applicationStore);
const { moveToLoanService } = useApplicationDetails();

const { features, loadFeatures } = useFeatures();

const mobileHidden = ref<boolean>(true);

const showMoveToLoanService = computed(() => {
  return (
    applicationStore.viewModel.statusName === "Complete" &&
    !applicationStore.viewModel.loanId
  );
});

const toggleIconClass = computed(() =>
  mobileHidden.value ? "icon-down-open-big" : "icon-up-open-big"
);

const LOCLimit = computed<string>(() => {
  return summary.value.loanAmount > 0 ? summary.value.loanAmountDisplay : "—";
});

const toggleApplicationDetailsMobile = () => {
  mobileHidden.value = !mobileHidden.value;
};

const showStepper = computed<boolean>(() => {
  return features.value?.locTimeline === true;
});

onMounted(() => {
  loadFeatures();
  functions.getType("ApplicationStatus");
});

return (_ctx: any,_cache: any) => {
  const _directive_title_overflow = _resolveDirective("title-overflow")!
  const _directive_auto_animate = _resolveDirective("auto-animate")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["component-wrapper", [showStepper.value]]),
    id: "application-detail"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["xpage-top-left", [{ hasStepper: showStepper.value }]])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(summary).primaryApplicantInitials), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _withDirectives((_openBlock(), _createElementBlock("h2", {
                title: _unref(summary).primaryApplicantFullName,
                class: "applicant-name fullname-wrap text-overflow-ellipsis"
              }, [
                _createTextVNode(_toDisplayString(_unref(summary).primaryApplicantFullName || "No Name"), 1)
              ], 8, _hoisted_7)), [
                [_directive_title_overflow]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _withDirectives((_openBlock(), _createElementBlock("h3", {
                  title: _unref(summary).lenderName
                }, [
                  _createTextVNode(_toDisplayString(_unref(summary).lenderName || "No Lender Provided"), 1)
                ], 8, _hoisted_10)), [
                  [_directive_title_overflow]
                ])
              ]),
              (_unref(applicationStore).isParentLOC)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _cache[1] || (_cache[1] = _createElementVNode("span", null, " Student:", -1)),
                    _createElementVNode("span", {
                      class: "text-wrap-auto",
                      title: 
                    _unref(summary).studentFullName
                      ? _unref(summary).studentFullName
                      : undefined
                  
                    }, "  " + _toDisplayString(_unref(summary).studentFullName), 9, _hoisted_12)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(PermissionsWrapper, {
                  showDisabledIfNotVisible: true,
                  permissionIds: [_unref(Permissions).ProgramConfiguration],
                  permissionLevel: _unref(PermissionLevels).Update
                }, {
                  default: _withCtx(() => [
                    _createVNode(ApplicationStatus)
                  ]),
                  _: 1
                }, 8, ["permissionIds", "permissionLevel"])
              ]),
              (showMoveToLoanService.value)
                ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("button", {
                      type: "submit",
                      class: "moveToLoanService-btn",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(moveToLoanService)(true)))
                    }, " Move To Loan Service » ")
                  ])), [
                    [_directive_auto_animate, { ..._ctx.$animate, duration: 100 }]
                  ])
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ], 2),
      (showStepper.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createVNode(DetailsStepper)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("a", {
        href: "#",
        class: _normalizeClass(toggleIconClass.value),
        onClick: _withModifiers(toggleApplicationDetailsMobile, ["prevent"])
      }, null, 2)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["application-summary-wrapper", { xhideformobile: mobileHidden.value }])
    }, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "label" }, "Line of Credit", -1)),
            _createElementVNode("div", _hoisted_20, _toDisplayString(LOCLimit.value), 1),
            _createElementVNode("div", _hoisted_21, "Requested " + _toDisplayString(_unref(summary).initialDrawAmount), 1)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "label" }, "Anticipated Graduation", -1)),
            _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(summary).graduationDate), 1),
            _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(applicationTab).school?.schoolName || "No School Provided"), 1)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "label" }, "Interest Rate", -1)),
            _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(summary).rate), 1),
            _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(summary).rateTypeName), 1)
          ])
        ])
      ])
    ], 2)
  ], 2))
}
}

})